export const QUEUE_MESSAGE = 'QUEUE_MESSAGE';
export const POP_MESSAGE = 'POP_MESSAGE';
export const DELIVER_TOP_MESSAGE = 'DELIVER_TOP_MESSAGE';

export function queueMessage(message) {
    return { type: QUEUE_MESSAGE, message };
}

export function popMessage() {
    return { type: POP_MESSAGE };
}

export function deliverTopMessage() {
    return { type: DELIVER_TOP_MESSAGE };
}
